import { orderTabs } from 'src/app/models/orderTabs.const';
import { SideBar } from '../../models/sideBar';
import { assetsConst } from './assets.const';
import { ModuleConst } from './moduleConst';
import { returnTabs } from 'src/app/models/returnTabs';

export const SideBarConst: Array<SideBar> = [
  {
    text: "DASHBOARD",
    path: "/dashboard",
    icon: assetsConst.dashBoardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard,
    accessTabs: []
  },
  {
    text: "MANAGECUSTOMERS",
    path: "/manage-user",
    icon: assetsConst.userIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Users,
    accessTabs: []
  },
  {
    text: "ManageVendors",
    path: "/manage-vendor",
    icon: assetsConst.vendorIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Vendors,
    accessTabs: []
  },
  {
    text: "ManageProducts",
    path: "",
    icon: assetsConst.productsIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.Products,
    accessTabs: [],
    subMenuItems: [
      {
        text: "Products Assign",
        path: "/products/list/1",
        icon: assetsConst.productsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.ProductsAssign,
        accessTabs: []
      },
      {
        text: "Products Approve",
        path: "/products/request/1",
        icon: assetsConst.productsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.ProductsApprove,
        accessTabs: []
      }
    ]
  },
  {
    text: "ManageBrands",
    path: "/manage-brands",
    icon: assetsConst.bookingsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Brands,
    accessTabs: []
  },
  {
    text: "ManageOutlets",
    path: "/manage-outlet/list/1",
    icon: assetsConst.bookingsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Outlet,
    accessTabs: []
  },
  {
    text: "ManagePayouts",
    path: "/manage-payout",
    icon: assetsConst.payoutIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.PayoutManage,
    subMenuItems: [
      {
        text: "Driver Payout",
        path: "/manage-payout/driver-payout",
        icon: assetsConst.payoutIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.DriverPayout,
        accessTabs: []
      },
      {
        text: "Factory Requests",
        path: "/manage-payout/factory-requests",
        icon: assetsConst.payoutIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.FactoryRequests,
        accessTabs: []
      },
      {
        text: "Vendor Payout",
        path: "/manage-payout/vendor-payout",
        icon: assetsConst.payoutIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.VendorPayout,
        accessTabs: []
      }
    ]
  },
  {
    text: "ManageSalesManager",
    path: "/sales-manager",
    icon: assetsConst.totaluserIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.SalesManager,
    accessTabs: [],
    subMenuItems: [
      {
        text: "Sales Manager",
        path: "/sales-manager",
        icon: assetsConst.userIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.SalesManager,
        accessTabs: []
      },
      {
        text: "Manage Area",
        path: "/manage-area",
        icon: assetsConst.AreaIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.ManageArea,
        accessTabs: []
      }
    ]
  },
  {
    text: "ManageFactories",
    path: "/manage-factory",
    icon: assetsConst.FactoryIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Factory,
    accessTabs: []
  },
  {
    text: "ManageDriver",
    path: "/manage-driver",
    icon: assetsConst.driverIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Driver || ModuleConst.Dispatcher,
    accessTabs: []
  },
  {
    text: "ManageDriverWallet",
    path: "/manage-driver-wallet",
    icon: assetsConst.reportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.DriverWallet,
    accessTabs: []
  },
  {
    text: "ManageReports",
    path: "/manage-report",
    icon: assetsConst.reportsIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.Reports || ModuleConst.Dispatcher,
    subMenuItems: [
      {
        text: "Vendor",
        path: "/manage-report/vendor-report/1",
        icon: assetsConst.vendorReportIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.VendorReport,
        accessTabs: []
      },
      {
        text: "Product Performance",
        path: "/manage-report/product-performance-report/1",
        icon: assetsConst.productPerformanceIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.ProductPerformanceReport,
        accessTabs: []
      },
      {
        text: "Coupon Usage",
        path: "/manage-report/coupon-usage-report/1",
        icon: assetsConst.couponsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.CouponUsageReport,
        accessTabs: []
      },
      {
        text: "Factory",
        path: "/manage-report/factory-report/1",
        icon: assetsConst.FactoryIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.FactoryReport,
        accessTabs: []
      },
      {
        text: "Earning",
        path: "/manage-report/earning-report",
        icon: assetsConst.analyticsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.EarningReport,
        accessTabs: []
      },
      {
        text: "Sales Summary",
        path: "/manage-report/collective-earning-report",
        icon: assetsConst.analyticsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.SalesSummaryReport,
        accessTabs: []
      },
      {
        text: "Transaction Summary",
        path: "/manage-report/transaction-summary/1",
        icon: assetsConst.analyticsIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.TransactionSummaryReport,
        accessTabs: []
      }
      // {
      //   text: 'Sales Report',
      //   path: '/manage-report/sales-report',
      //   icon: assetsConst.analyticsIcon,
      //   isSubMenu: false,
      //   sideBarId: ModuleConst.SalesReport
      // }
    ],
  },
  {
    text: "ManageDispatcher",
    path: "/manage-dispatcher",
    icon: assetsConst.totaluserIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dispatcher,
    accessTabs: []
  },
  {
    text: "Geofence",
    path: "/manage-geofencing",
    icon: assetsConst.locationIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Geofence || ModuleConst.Dispatcher,
    accessTabs: []
  },
  {
    text: "ManageVehicle",
    path: "/manage-vehicle",
    icon: assetsConst.vehicleIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Vehicle || ModuleConst.Dispatcher,
    accessTabs: []
  },
  // {
  //   text: 'ManageBookings',
  //   path: '/manage-bookings',
  //   icon: assetsConst.bookingsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Booking
  // },

  {
    text: "ManageProductCategory",
    path: "/manage-product-category/list/1",
    icon: assetsConst.productcategoryicon,
    isSubMenu: false,
    sideBarId: ModuleConst.Category,
    accessTabs: []
  },
  {
    text: 'ManageHomeSection',
    path: '/manage-home-section',
    icon: assetsConst.dashBoardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.HomeSection,
    accessTabs: []
  },
  {
    text: "ManageTeams",
    path: "/manage-teams",
    icon: assetsConst.teamsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Teams || ModuleConst.Dispatcher,
    accessTabs: []
  },
  // {
  //   text: 'Pricing',
  //   path: '/pricing',
  //   icon: assetsConst.pricingIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Pricing
  // },
  // {
  //   text: 'Tools',
  //   path: '/tools',
  //   icon: assetsConst.toolsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Tools
  // },

  {
    text: "OrderManagement",
    icon: assetsConst.manageorderIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.Orders,
    accessTabs: [],
    subMenuItems: [
      {
        text: "Orders",
        path: "/manage-order",
        icon: assetsConst.orderIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.Orders,
        accessTabs: [
          {
            key: 'allOrders',
            text:'All Orders',
            id: orderTabs.ALL
          },
          {
            key: 'pending',
            text:'Pending',
            id: orderTabs.Pending
          },
          {
            key: 'accepted',
            text:'Accepted',
            id: orderTabs.Accepted
          },
          {
            key: 'readyToPickUp',
            text:'Ready to Pick Up',
            id: orderTabs.ReadyToPickUp
          },
          {
            key: 'assignedToTeam',
            text:'Assigned to Team',
            id: orderTabs.AssignedToTeam
          },
          {
            key: 'assignedToDriver',
            text:'Assigned to Driver',
            id: orderTabs.AssignedToDriver
          },
          {
            key: 'orderAcceptedByDriver',
            text:'Order Accepted by Driver',
            id: orderTabs.OrderAcceptedByDriver
          },
          {
            key: 'reachedPickupLocation',
            text:'Reached Pickup Location',
            id: orderTabs.ReachedPickupLocation
          },
          {
            key: 'orderPickedUp',
            text:'Order Picked up',
            id: orderTabs.OrderPickedUp
          },
          {
            key: 'onTheWay',
            text:'On The Way',
            id: orderTabs.OnTheWay
          },
          {
            key: 'delivered',
            text:'Delivered',
            id: orderTabs.Delivered
          },
          {
              key: 'cancelledByUser',
            text:'Cancelled By User',
            id: orderTabs.CancelledByUser
          },
          {
            key: 'cancelledByAdmin',
            text:'Cancelled By Admin',
            id: orderTabs.CancelledByAdmin
          },
          {
            key: 'orderNotAccepted',
            text:'Order Not Accepted',
            id: orderTabs.OrderNotAccepted
          },
          {
            key: 'substituteProductRequested',
            text:'SubstituteRequested',
            id: orderTabs.SubstituteProductRequested
          }
        ]
      },
      {
        text: "Returns",
        path: "/manage-order/returns/0/1",
        icon: assetsConst.returnIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.Returns,
        accessTabs: [
          {
            key: 'requestReturn',
            text:'Pending',
            id: returnTabs.REQUEST_RETURN
          },
          {
            key: 'returnAccepted',
            text:'Return Accepted',
            id: returnTabs.RETURN_ACCEPTED
          },
          {
            key: 'assignedToTeam',
            text:'Assigned to Team',
            id: returnTabs.AssignedToTeam
          },
          {
            key: 'assignedToDriver',
            text:'Assigned to Driver',
            id: returnTabs.AssignedToDriver
          },
          {
            key: 'orderAcceptedByDriver',
            text:'Order Accepted by Driver',
            id: returnTabs.OrderAcceptedByDriver
          },
          {
            key: 'reachedPickupLocation',
            text:'Reached Pickup Location',
            id: returnTabs.ReachedPickupLocation
          },
          {
            key: 'orderPickedUp',
            text:'Order Picked up',
            id: returnTabs.OrderPickedUp
          },
          {
            key: 'onTheWay',
            text:'On The Way',
            id: returnTabs.OnTheWay
          },
          {
            key: 'delivered',
            text:'Received',
            id: returnTabs.Delivered
          },
          {
            key: 'returnRejected',
            text:'Cancelled',
            id: returnTabs.RETURN_REJECTED
          },
          {
            key: 'qualityCheck',
            text:'Quality Check',
            id: returnTabs.QualityCheck
          }
        ]
      }
    ]
  },
  // {
  //   text: 'ManagePayments',
  //   path: 'payments',
  //   icon: assetsConst.paymentsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Payments
  // },
  // {
  //   text: 'SalesReports',
  //   path: '/sales-report',
  //   icon: assetsConst.analyticsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Coordinator
  // },
  {
    text: "ManageSubAdmin",
    path: "/subadmin",
    icon: assetsConst.totaluserIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SubAdmin,
    accessTabs: []
  },
  {
    text: "ManageCoupons",
    path: "/discount",
    icon: assetsConst.couponsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Discount,
    accessTabs: []
  },
  {
    text: "ManageDiscountDeal",
    path: "/manage-discount-deal",
    icon: assetsConst.couponsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.DiscountDeal,
    accessTabs: []
  },
  {
    text: "AdBanner",
    path: "/banners",
    icon: assetsConst.adIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Banners,
    accessTabs: []
  },
  {
    text: "AdvertisementPopup",
    path: "/advertisement-popup",
    icon: assetsConst.adIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.AdvertisementPopup,
    accessTabs: []
  },
  {
    text: "CustomerSupport",
    path: "/support-chat",
    icon: assetsConst.subAdminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.ChatSupport,
    accessTabs: []
  },
  {
    text: "ManageReviews",
    path: "/ratings-review",
    icon: assetsConst.reviewIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Review,
    accessTabs: []
  },
  {
    text: "Notification",
    path: "/notification",
    icon: assetsConst.noteIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Notification,
    accessTabs: []
  },
  {
    text: "CMS",
    path: "/cms",
    icon: assetsConst.cmsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Cms,
    accessTabs: []
  },
  {
    text: "Setting",
    path: "/settings",
    icon: assetsConst.settingIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Settings,
    accessTabs: []
  }
];
